"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CallToAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section ref={ref} className={`w-full bg-primary py-16 px-4 transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)]
        ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}
      `}>
      <div className="max-w-4xl mx-auto text-center flex flex-col items-center gap-6">
        <h2 className="text-3xl font-bold !text-[hsl(210,17%,98%)] md:text-4xl lg:text-5xl">
          Bereit für Ihr nächstes Event?
        </h2>

        <p className="text-lg max-w-2xl !text-[hsl(210,17%,98%)] !font-semibold md:text-xl">
          Kontaktieren Sie uns jetzt und lassen Sie uns gemeinsam Ihr unvergessliches Event planen.
        </p>

        <Button asChild size="lg" className="bg-accent text-gray-900 hover:bg-accent-hover active:bg-accent-active shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:shadow-strong hover:-translate-y-1">
          <Link to="/ContactPage" className="!text-3xl">
            Jetzt anfragen
          </Link>
        </Button>
      </div>
    </section>;
}